import StorageKeys from "Utility/StorageKey.js";
import PersonalStorageKeys from "Utility/PersonalStorageKey.js";
import ChurchKey from "Utility/ChurchKey.js";
class StorageBox {
  inputUserDataStorageId(data) {
    const dataString = JSON.stringify(data); // Convert the data to a JSON string
    localStorage.setItem(StorageKeys.UserData, dataString);
  }

  inputUserDetails(data) {
    console.log(StorageKeys.UserData);
    console.log("apalah");
    console.log(data);
    localStorage.setItem(StorageKeys.EMAIL, data.email);
    localStorage.setItem(StorageKeys.BIBLEVERSE, data.BIBLEVERSE);
    localStorage.setItem(StorageKeys.UserHighlight, data.UserHighlight);
    localStorage.setItem(StorageKeys.UserName, data.UserName);
    localStorage.setItem(StorageKeys.UserReligion, data.UserReligion);
    console.log("apalah");
    console.log(data);
  }

  inputUserProfileDataStorageId(data) {
    const dataString = JSON.stringify(data); // Convert the data to a JSON string
    localStorage.setItem(PersonalStorageKeys.UserData, dataString);
  }

  inputUserProfileDetails(data) {
    console.log(PersonalStorageKeys.UserData);
    console.log("apalah");
    console.log(data);
    localStorage.setItem(PersonalStorageKeys.EMAIL, data.email);
    localStorage.setItem(PersonalStorageKeys.BIBLEVERSE, data.BIBLEVERSE);
    localStorage.setItem(PersonalStorageKeys.UserHighlight, data.UserHighlight);
    localStorage.setItem(PersonalStorageKeys.UserName, data.UserName);
    localStorage.setItem(PersonalStorageKeys.UserReligion, data.UserReligion);
    console.log("apalah");
    console.log(data);
  }

  getProfileUserData() {
    return JSON.parse(localStorage.getItem(PersonalStorageKeys.UserData));
  }

  getProfileUserName() {
    var item = localStorage.getItem(PersonalStorageKeys.UserName);
    return item;
  }

  getProfileUserReligion() {
    var item = localStorage.getItem(PersonalStorageKeys.UserReligion);
    return item;
  }

  getUserData() {
    return JSON.parse(localStorage.getItem(StorageKeys.UserData));
  }

  getUserName() {
    var item = localStorage.getItem(StorageKeys.UserName);
    return item;
  }

  getUserReligion() {
    var item = localStorage.getItem(StorageKeys.UserReligion);
    return item;
  }

  outputStorageId() {}

  removeAllUserDetails() {
    localStorage.clear();
    sessionStorage.clear();
  }

  removePictureBackgroundProfile() {
    localStorage.removeItem(StorageKeys.PictureBackground);
    localStorage.removeItem(StorageKeys.PictureProfile);
    sessionStorage.removeItem(StorageKeys.PictureBackground);
    sessionStorage.removeItem(StorageKeys.PictureProfile);
  }

  inputUserComment(data) {
    const dataString = JSON.stringify(data);
    localStorage.setItem(StorageKeys.UserComment, dataString);
  }

  // Church-related methods
  inputChurchDetails(data) {
    if (data.name) {
      localStorage.setItem(ChurchKey.ChurchName, data.name);
    }
    if (data.introduction) {
      localStorage.setItem(ChurchKey.ChurchIntroduction, data.introduction);
    }
    if (data.imagesName) {
      localStorage.setItem(ChurchKey.ChurchImagesName, data.imagesName);
    }
    if (data.id) {
      localStorage.setItem(ChurchKey.ChurchId, data.id);
    }
    if (data.personCreate) {
      localStorage.setItem(ChurchKey.ChurchPersonCreate, data.personCreate);
    }
    if (data.userJoin) {
      console.log(
        "StorageBox.inputChurchDetails - userJoin before save:",
        data.userJoin
      );
      console.log(
        "StorageBox.inputChurchDetails - userJoin type:",
        typeof data.userJoin
      );
      console.log(
        "StorageBox.inputChurchDetails - userJoin isArray:",
        Array.isArray(data.userJoin)
      );

      // Handle if userJoin is already a string (from Supabase JSON column)
      let userJoinToStore = data.userJoin;

      // If it's a string, parse it first
      if (typeof data.userJoin === "string") {
        try {
          userJoinToStore = JSON.parse(data.userJoin);
          console.log(
            "StorageBox.inputChurchDetails - Parsed string to array:",
            userJoinToStore
          );
        } catch (e) {
          console.error(
            "StorageBox.inputChurchDetails - Error parsing userJoin string:",
            e
          );
          userJoinToStore = [];
        }
      }

      // Ensure it's an array before storing
      if (!Array.isArray(userJoinToStore)) {
        console.warn(
          "StorageBox.inputChurchDetails - userJoin is not an array, converting:",
          userJoinToStore
        );
        userJoinToStore = [];
      }

      const jsonString = JSON.stringify(userJoinToStore);
      console.log(
        "StorageBox.inputChurchDetails - Storing as string:",
        jsonString
      );
      localStorage.setItem(ChurchKey.ChurchUserJoin, jsonString);
    }
    if (data.userPending) {
      console.log(
        "StorageBox.inputChurchDetails - userPending before save:",
        data.userPending
      );
      console.log(
        "StorageBox.inputChurchDetails - userPending type:",
        typeof data.userPending
      );
      console.log(
        "StorageBox.inputChurchDetails - userPending isArray:",
        Array.isArray(data.userPending)
      );

      // Handle if userPending is already a string (from Supabase JSON column)
      let userPendingToStore = data.userPending;

      // If it's a string, parse it first
      if (typeof data.userPending === "string") {
        try {
          userPendingToStore = JSON.parse(data.userPending);
          console.log(
            "StorageBox.inputChurchDetails - Parsed string to array:",
            userPendingToStore
          );
        } catch (e) {
          console.error(
            "StorageBox.inputChurchDetails - Error parsing userPending string:",
            e
          );
          userPendingToStore = [];
        }
      }

      // Ensure it's an array before storing
      if (!Array.isArray(userPendingToStore)) {
        console.warn(
          "StorageBox.inputChurchDetails - userPending is not an array, converting:",
          userPendingToStore
        );
        userPendingToStore = [];
      }

      const jsonString = JSON.stringify(userPendingToStore);
      console.log(
        "StorageBox.inputChurchDetails - Storing userPending as string:",
        jsonString
      );
      localStorage.setItem(ChurchKey.ChurchUserPending, jsonString);
    }
  }

  getChurchName() {
    return localStorage.getItem(ChurchKey.ChurchName);
  }

  getChurchIntroduction() {
    return localStorage.getItem(ChurchKey.ChurchIntroduction);
  }

  getChurchImagesName() {
    return localStorage.getItem(ChurchKey.ChurchImagesName);
  }

  getChurchId() {
    return localStorage.getItem(ChurchKey.ChurchId);
  }

  getChurchPersonCreate() {
    return localStorage.getItem(ChurchKey.ChurchPersonCreate);
  }

  getChurchUserJoin() {
    const userJoinStr = localStorage.getItem(ChurchKey.ChurchUserJoin);
    console.log("StorageBox - getChurchUserJoin raw string:", userJoinStr);
    console.log(
      "StorageBox - getChurchUserJoin raw string type:",
      typeof userJoinStr
    );

    if (userJoinStr) {
      try {
        let parsed = JSON.parse(userJoinStr);
        console.log("StorageBox - getChurchUserJoin first parse:", parsed);
        console.log(
          "StorageBox - getChurchUserJoin first parse type:",
          typeof parsed
        );
        console.log(
          "StorageBox - getChurchUserJoin isArray after first parse:",
          Array.isArray(parsed)
        );

        // If it's still a string after first parse, parse again (double-stringified)
        if (typeof parsed === "string") {
          console.log(
            "StorageBox - Detected double-stringified data, parsing again..."
          );
          parsed = JSON.parse(parsed);
          console.log("StorageBox - getChurchUserJoin second parse:", parsed);
          console.log(
            "StorageBox - getChurchUserJoin isArray after second parse:",
            Array.isArray(parsed)
          );
        }

        // Ensure we return an array
        if (Array.isArray(parsed)) {
          console.log(
            "StorageBox - Returning array with",
            parsed.length,
            "items"
          );
          return parsed;
        } else {
          console.warn(
            "StorageBox - userJoin is not an array after parsing:",
            parsed
          );
          console.warn("StorageBox - userJoin actual type:", typeof parsed);
          return [];
        }
      } catch (e) {
        console.error("StorageBox - Error parsing userJoin:", e);
        return [];
      }
    }
    console.log("StorageBox - No userJoin data in localStorage");
    return [];
  }

  getChurchUserPending() {
    const userPendingStr = localStorage.getItem(ChurchKey.ChurchUserPending);
    console.log(
      "StorageBox - getChurchUserPending raw string:",
      userPendingStr
    );
    console.log(
      "StorageBox - getChurchUserPending raw string type:",
      typeof userPendingStr
    );

    if (userPendingStr) {
      try {
        let parsed = JSON.parse(userPendingStr);
        console.log("StorageBox - getChurchUserPending first parse:", parsed);
        console.log(
          "StorageBox - getChurchUserPending first parse type:",
          typeof parsed
        );
        console.log(
          "StorageBox - getChurchUserPending isArray after first parse:",
          Array.isArray(parsed)
        );

        // If it's still a string after first parse, parse again (double-stringified)
        if (typeof parsed === "string") {
          console.log(
            "StorageBox - Detected double-stringified data, parsing again..."
          );
          parsed = JSON.parse(parsed);
          console.log(
            "StorageBox - getChurchUserPending second parse:",
            parsed
          );
          console.log(
            "StorageBox - getChurchUserPending isArray after second parse:",
            Array.isArray(parsed)
          );
        }

        // Ensure we return an array
        if (Array.isArray(parsed)) {
          console.log(
            "StorageBox - Returning array with",
            parsed.length,
            "items"
          );
          return parsed;
        } else {
          console.warn(
            "StorageBox - userPending is not an array after parsing:",
            parsed
          );
          console.warn("StorageBox - userPending actual type:", typeof parsed);
          return [];
        }
      } catch (e) {
        console.error("StorageBox - Error parsing userPending:", e);
        return [];
      }
    }
    console.log("StorageBox - No userPending data in localStorage");
    return [];
  }

  clearChurchDetails() {
    localStorage.removeItem(ChurchKey.ChurchName);
    localStorage.removeItem(ChurchKey.ChurchIntroduction);
    localStorage.removeItem(ChurchKey.ChurchImagesName);
    localStorage.removeItem(ChurchKey.ChurchId);
    localStorage.removeItem(ChurchKey.ChurchPersonCreate);
    localStorage.removeItem(ChurchKey.ChurchUserJoin);
    localStorage.removeItem(ChurchKey.ChurchUserPending);
  }

  // Store full churches array
  inputChurchesArray(churches) {
    if (churches && Array.isArray(churches)) {
      const jsonString = JSON.stringify(churches);
      localStorage.setItem("churches_array", jsonString);
    }
  }

  // Get full churches array
  getChurchesArray() {
    const churchesStr = localStorage.getItem("churches_array");
    if (churchesStr) {
      try {
        return JSON.parse(churchesStr);
      } catch (e) {
        console.error("Error parsing churches array:", e);
        return null;
      }
    }
    return null;
  }

  // Clear churches array
  clearChurchesArray() {
    localStorage.removeItem("churches_array");
  }
}

export default new StorageBox();
